import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

const styles = require('./link-button-component.styles.scss');


export const LinkButtonComponent = ({ to, children, className }) => {
  let component;

  if (to.startsWith('/')) {
    component = (
      <Link to={to} className={classnames(styles.LinkButton, className)}>
        { children }
      </Link>
    );
  } else {
    component = (
      <a href={to} className={classnames(styles.LinkButton, className)}>
        { children }
      </a>
    )
  }

  return component;
};



// WEBPACK FOOTER //
// ./src/components/button/link-button/link-button.component.jsx